import React from 'react';


export const CalendarEventPopoverActionsContext = React.createContext<React.MutableRefObject<{ updatePosition(): void }>>({
  current: {
    updatePosition: () => undefined
  }
});


export const useCalendarEventPopoverActions = () => {
  return React.useContext(CalendarEventPopoverActionsContext);
};
